import { mapGetters, mapState } from 'vuex'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'
import { unwrapApiPayload } from '@/utils/graphql'
import { normalizeSessionPayload } from '@/utils/session'
import { loadOrgDetailsIntoStore } from '@/utils/orgDetailsLoader'
import { formatDateTime } from '@/utils/format'

export default {
  computed: {
    ...mapState(['sessionLoading', 'organization', 'orgId', 'landingOrganization', 'orgDetailsLoading']),
    ...mapGetters(['isSessionReady']),
    pageLoading() {
      return this.sessionLoading || !this.isSessionReady || this.orgDetailsLoading
    },
    displayOrganization() {
      return {
        ...this.landingOrganization,
        ...this.organization,
        org_id: this.organization.org_id || this.orgId || '',
        sip_number:
          this.organization.sip_number ||
          this.landingOrganization?.sip_number ||
          '',
      }
    },
    organizationForDialog() {
      return { ...this.displayOrganization }
    },
    lastUpdatedTimestamp() {
      const org = this.displayOrganization
      return org.last_updated_on ?? org.created_on ?? null
    },
    lastUpdatedLabel() {
      if (this.displayOrganization.last_updated_on) return 'Updated'
      if (this.displayOrganization.created_on) return 'Created'
      return 'Updated'
    },
    lastUpdatedDisplay() {
      const formatted = formatDateTime(this.lastUpdatedTimestamp)
      return formatted && formatted !== '—' ? formatted : '—'
    },
  },
  methods: {
    showSnack(color, text) {
      this.SnackbarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: color,
        SnackbarText: text,
      }
    },
    onError(payload, fallback = 'Failed to save.') {
      this.showSnack('error', getApiMessage(payload, fallback))
    },
    async refreshOrganizationFromApi() {
      await loadOrgDetailsIntoStore(this.$store)
    },
    async onSaved(response, successFallback = 'Saved successfully.') {
      const unwrapped = unwrapApiPayload(response)
      const orgUpdate =
        unwrapped?.orgDetails ??
        normalizeSessionPayload(response)?.organization ??
        unwrapped

      if (orgUpdate && typeof orgUpdate === 'object') {
        const mapped = normalizeSessionPayload({
          status: 'SUCCESS',
          data: { items: { orgDetails: orgUpdate } },
        })?.organization
        this.$store.commit('UPDATE_ORGANIZATION', mapped ?? orgUpdate)
      }

      try {
        await this.refreshOrganizationFromApi()
      } catch (err) {
        this.showSnack(
          'warning',
          getApiMessage(err, 'Saved, but failed to refresh details.'),
        )
        return
      }

      this.showSnack('success', getApiMessage(response, successFallback))
    },
  },
}
